import { useTranslations } from 'next-intl'

import { NoResultIcon } from '../assets/icons'

export function NoSearchResults({
  currentFilter,
  resetFilters,
}: {
  currentFilter?: string
  resetFilters: () => void
}) {
  const t = useTranslations('pages.clubhouse')
  return (
    <div className="flex flex-col items-center justify-center px-8 pt-10">
      <NoResultIcon className="mb-2" />
      <h2 className="mb-2.5 w-full text-center text-[18px] font-bold leading-[26px]">
        {currentFilter
          ? t('no_results.title_with_filter', { filter: currentFilter })
          : t('no_results.title')}
      </h2>
      <p className="text-16 text-center leading-6">
        {currentFilter ? t('no_results.description_with_filter') : t('no_results.description')}
        {currentFilter ? (
          <span
            role="button"
            onClick={resetFilters}
            className="font-medium text-[#113CB9] underline underline-offset-[6px]"
          >
            {t('no_results.try_all_categories')}
          </span>
        ) : null}
      </p>
    </div>
  )
}
